import React from "react";
import { Icon } from "antd";
import styles from "./singleSelectHeader.scss";

const SingleSelectHeader = ({ title, onCancel }) => (
  <div className={styles.header}>
    <span className={styles.title}>
      {title || "Kategorija"}
    </span>
    <Icon type="close" onClick={onCancel} className={styles.closeButton} />
  </div>
);

SingleSelectHeader.defaultProps = {
  title: ""
};

export default SingleSelectHeader;



// WEBPACK FOOTER //
// ./src/components/FormControls/SingleColorSelector/MobileDropdownSelect/SingleSelectModal/SingleSelectHeader/index.tsx